import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout/Layout";
import {
  useAcceptAuditMutation,
  useCancelAuditsMutation,
  useGetViewAuditsQuery,
  usePartialApproveAuditMutation,
  useRejectAuditMutation,
} from "../../../store/Api/audits";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import ViewECAAuditListUi from "./ViewECAAuditsListUi";
import { useSelector } from "react-redux";
const validationSchema = Yup.object().shape({
  reason: Yup.string()
  .required("Reason is required"),
});
function ViewECAAuditList() {
  // const { id } = useParams();
  const location = useLocation(); // Access state
  const { state } = location;
  const id = state?.data?.id
  const navigate = useNavigate();
  const [cancelAudits] = useCancelAuditsMutation();
  const [acceptAudit] = useAcceptAuditMutation();
  const [rejectAudit] = useRejectAuditMutation();
  const [parsialApprovaAudit] = usePartialApproveAuditMutation();
  const selectedCEN = useSelector((state) => state.cen.selectedCEN);
  const auditorName = `${state?.data?.user?.firstname} ${state?.data?.user?.lastname}`;
  //   const [data,setData] = useState({});
  const [auditData, setAuditData] = useState({});
  const [imagesAuditData, setImagesAuditData] = useState("");
 const [showForm,setShowForm] = useState(false);
  
  const { data, isFetching, isLoading, refetch } = useGetViewAuditsQuery({
    centre_id: id,
  });
  
  useEffect(() => {
    if (data) {
      const tdata = data?.data?.eca_audit?.audit_data;
      const userAuditdata = data?.data?.audit?.audit_data;

      const filteredUserAuditData = Object.fromEntries(
        userAuditdata ? Object.entries(userAuditdata)?.filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            value?.input_type !== "media"
        )
        : []
      );
      const filteredAuditData = Object.fromEntries(
        Object.entries(tdata)?.filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            value?.input_type !== "media"
        )
      );
      const filteredImagesAuditData = Object.fromEntries(
        Object.entries(tdata)?.filter(
          ([key, value]) => value?.input_type == "media"
          
        )
      );
      const result = mergeData(filteredUserAuditData,filteredAuditData);

      setImagesAuditData(filteredImagesAuditData);
      // setAuditData(filteredAuditData);
      setAuditData(result);

    }
  }, [data]);
  
  function mergeData(auditData, ecaauditdata) {
    const mergedData = {};
  
    // Helper function to recursively merge subquestions
    function mergeSubquestions(auditSub, ecaSub) {
        const mergedSub = { ...auditSub };
  
        if (ecaSub) {
            mergedSub.eca_answer = ecaSub.user_answer;
            mergedSub.user_answer = auditSub.user_answer;
            mergedSub.history = [...(auditSub.history || []), ...(ecaSub.history || [])];
  
            // Recursively merge subquestions if they exist
            if (auditSub.sub_question || ecaSub.sub_question) {
                mergedSub.sub_question = {};
  
                const allSubKeys = new Set([
                    ...Object.keys(auditSub.sub_question || {}),
                    ...Object.keys(ecaSub.sub_question || {}),
                ]);
  
                for (const subKey of allSubKeys) {
                    mergedSub.sub_question[subKey] = mergeSubquestions(
                        auditSub.sub_question?.[subKey] || {},
                        ecaSub.sub_question?.[subKey] || {}
                    );
                }
            }
        }
  
        return mergedSub;
    }
  
    // Iterate over the keys in auditData
    for (const key in auditData) {
        if (ecaauditdata[key]) {
            // Merge the main level data
            mergedData[key] = mergeSubquestions(auditData[key], ecaauditdata[key]);
        } else {
            // If key only exists in auditData
            mergedData[key] = auditData[key];
        }
    }
  
    // Add keys from ecaauditdata that don't exist in auditData
    for (const key in ecaauditdata) {
        if (!auditData[key]) {
            mergedData[key] = ecaauditdata[key];
        }
    }
  
    return mergedData;
  }

//   const deleteAuditFn = async () => {
//     try {
//       const response = await cancelAudits({ id: state?.data?.id });
//       if (response?.data?.success) {
//         navigate("/audits");
//       }
//     } catch (error) {
//       console.log(error, "verify otp error");
//     }
//   };

//   const acceptAudits = async () => {
//     try {
//       const response = await acceptAudit({ id: state?.data?.id });
//       if (response?.data?.success) {
//         navigate("/audits");
//       }
//     } catch (error) {
//       console.log(error, "verify otp error");
//     }
//   };

//   const rejectAudits= async (values, { resetForm })=>{
//       const data =values
//     try {
//         const response =  await rejectAudit({ id:state?.data?.id , data })
//         if (response?.data?.success) { 
//           navigate("/audits");       
//           setShowForm(false);
//         }
//       } catch (error) {
//         console.log(error, "verify otp error");
//       }
// }
//   const parsialApprovaAudits = async () => {
//     navigate(`/audits/partial-approve/${state?.data?.id}`);
//   };
  
  return (
    <Layout>
      <ViewECAAuditListUi
        data={data?.data}
        auditData={auditData}
        loading={isLoading}
        auditorName={auditorName}
        // deleteAuditFn={deleteAuditFn}
        imagesAuditData={imagesAuditData}
        // acceptAudits={acceptAudits}
        // rejectAudits={rejectAudits}
        validationSchema={validationSchema}
        setShowForm={setShowForm}
        showForm={showForm}
        // parsialApprovaAudits={parsialApprovaAudits}
        selectedCEN={selectedCEN}
      />
    </Layout>
  );
}

export default ViewECAAuditList;
